export default {"src":"/_next/static/image/public/images/rx_delivery.ee2a0046ec9ea363ffcb072d70748fb7.svg","height":40,"width":40};